<nz-form-item class="ui-form-date">
  <nz-form-label *ngIf="!hideLabel" [nzRequired]="isRequired">{{
    label | localization
  }}</nz-form-label>
  <nz-form-control
    [nzValidateStatus]="control ?? 'success'"
    [nzErrorTip]="errorTip | localization"
  >
    <nz-date-picker
      #datePicker
      [(ngModel)]="value"
      (ngModelChange)="onDateChanged($event)"
      [nzDisabledDate]="disabledDate"
      [nzShowTime]="showTimeFormat"
      [nzMode]="mode"
      [nzFormat]="format"
      [nzAllowClear]="!required"
      nzDropdownClassName="ui-form-date-dropdown"
      [nzPlaceHolder]="placeholder | localization"
      [disabled]="disabled"
      [nzInputReadOnly]="false"
    ></nz-date-picker>
  </nz-form-control>
</nz-form-item>
